import { EstadisticasLlave } from "../../bussines/entities/EstadisticasLlave.entity";

export class EstadisticasLlaveModel implements EstadisticasLlave {
    constructor(
        public totalLlavesActivas: number,
        public nuevasLlavesMes: number,
        public promedioLlavesPorCliente: number
    ) { }

    serialize(): EstadisticasLlave {
        return {
            totalLlavesActivas: this.totalLlavesActivas,
            nuevasLlavesMes: this.nuevasLlavesMes,
            promedioLlavesPorCliente: this.promedioLlavesPorCliente
        }
    }

    static deserialize(entity: EstadisticasLlave): EstadisticasLlaveModel {
        return new EstadisticasLlaveModel(
            entity.totalLlavesActivas ?? 0,
            entity.nuevasLlavesMes ?? 0,
            entity.promedioLlavesPorCliente ?? 0
        );
    }
}